import { Box } from '@mui/material';

import { About, Benefits, Ecosystem, FeaturedIn, Intro, Team, UseCases } from './ui';

export const Home = () => {
  return (
    <Box>
      <Intro />
      <About />
      <FeaturedIn />
      <UseCases />
      <Ecosystem />
      <Benefits />
      <Team />
    </Box>
  );
};
